<template>
  <lazy-library-container v-if="variant === variants.v1" class="tw-py-24">
    <div class="container text-center tw-mb-10">
      <lazy-library-title :text="vars.titleHtml" tag="h3"></lazy-library-title>
    </div>

    <div class="pxp-areas-carousel tw-mt-20 tw-px-0">
      <div class="pxp-areas-carousel-stage knowledge-hub-carousel-stage owl-carousel">
        <theme3-components-guide-box
          v-for="(item, index) in items"
          :key="`knowledge-hub-${key}-${index}`"
          class="pxp-areas-carousel-item"
          :item="item"
          :component="component"
          style-name="v1"
        >
        </theme3-components-guide-box>
      </div>
    </div>

    <div class="container">
      <div class="text-center mt-4 mt-md-5">
        <nuxt-link :to="vars.ctaUrl" style="color: var(--purple)" class="pxp-primary-cta text-uppercase pxp-animate">
          {{ vars.ctaText }}
        </nuxt-link>
      </div>
    </div>
  </lazy-library-container>
  <lazy-library-container v-if="variant === variants.v2" class="tw-py-24">
    <div class="container text-center tw-mb-10">
      <lazy-library-title :text="vars.titleHtml" tag="h3"></lazy-library-title>
    </div>

    <div class="pxp-areas-carousel tw-px-0">
      <div class="pxp-areas-carousel-stage knowledge-hub-carousel-stage owl-carousel knowledge-hub-variant-2">
        <div v-for="(item, index) in items" :key="`knowledge-hub-${key}-${index}`">
          <theme3-components-guide-box :item="item" :component="component" style-name="v2">
          </theme3-components-guide-box>
        </div>
      </div>
    </div>

    <div v-if="vars.ctaUrl && vars.ctaText" class="container">
      <div class="text-center mt-4 mt-md-5">
        <nuxt-link :to="vars.ctaUrl" style="color: var(--purple)" class="pxp-primary-cta text-uppercase pxp-animate">
          {{ vars.ctaText }}
        </nuxt-link>
      </div>
    </div>
  </lazy-library-container>


<!-- v4 -->
<lazy-library-container v-if="variant === variants.v4" class="tw-py-24 guide-box">
  <div class="container text-center tw-mb-10">
    <lazy-library-title :text="vars.titleHtml" tag="h3"></lazy-library-title>
  </div>

  <div class="pxp-areas-carousel tw-mt-20 tw-px-0">
    <div class="pxp-areas-carousel-stage knowledge-hub-carousel-stage owl-carousel">
      <theme3-components-guide-box
        v-for="(item, index) in items"
        :key="`knowledge-hub-${key}-${index}`"
        class="pxp-areas-carousel-item"
        :item="item"
        :component="component"
        style-name="v6"
        @click.prevent="handleItemClick(item)"  
      />
    </div>
  </div>

  <div class="container">
    <div class="text-center mt-4 mt-md-5">
      <nuxt-link :to="vars.ctaUrl" style="color: var(--white)" class="pxp-primary-cta text-uppercase pxp-animate">
        {{ vars.ctaText }}
      </nuxt-link>
    </div>
  </div>

  
  <popup
    v-if="selectedItem && popupConfig.isActive"
    :config="popupConfig"
    custom-width="90%"
    @close="closePopup"
  >
    <template #content>
      <library-form
        v-if="selectedItem.formData"
        :form="selectedItem.formData"
        version="v2"
        :component="component"
      />
    </template>
  </popup>
</lazy-library-container>

  <div v-if="variant === variants.v1Sidebar">
    <div>
      <lazy-library-title :text="vars.titleHtml" tag="h3"></lazy-library-title>
    </div>

    <div v-if="vars.ctaUrl && vars.ctaText" class="tw-mt-4">
      <nuxt-link :to="vars.ctaUrl" style="color: var(--purple)" class="pxp-primary-cta text-uppercase pxp-animate">
        {{ vars.ctaText }}
      </nuxt-link>
    </div>

    <div class="pxp-areas-carousel tw-mt-4 tw-px-0">
      <div class="pxp-areas-carousel-stage knowledge-hub-carousel-stage-sidebar owl-carousel">
        <theme3-components-guide-box
          v-for="(item, index) in items"
          :key="`knowledge-hub-${key}-${index}`"
          class="pxp-areas-carousel-item"
          :item="item"
          :component="component"
          style-name="v1"
        >
        </theme3-components-guide-box>
      </div>
    </div>
  </div>

  <div v-if="variant === variants.v2Sidebar">
    <div>
      <h4>{{ vars.titleText }}</h4>
    </div>

    <!-- Global CTA -->
    <div v-if="vars.ctaUrl && vars.ctaText" class="tw-mt-4">
      <nuxt-link :to="vars.ctaUrl" style="color: var(--purple)" class="pxp-primary-cta text-uppercase pxp-animate">
        {{ vars.ctaText }}
      </nuxt-link>
    </div>

    <!-- Items carousel -->
    <div class="pxp-areas-carousel tw-mt-4 tw-px-0">
      <div class="pxp-areas-carousel-stage knowledge-hub-carousel-stage-sidebar owl-carousel">
        <theme3-components-guide-box
          v-for="(item, index) in items"
          :key="`knowledge-hub-${key}-${index}`"
          class="pxp-areas-carousel-item"
          :item="item"
          :component="component"
          style-name="v3"
          @click.prevent="handleItemClick(item)"
        />
      </div>
    </div>

    <!-- Popup for forms -->
    <popup v-if="selectedItem && popupConfig.isActive" :config="popupConfig" custom-width="90%" @close="closePopup">
      <template #content>
        <library-form v-if="selectedItem.formData" :form="selectedItem.formData" version="v2" :component="component" />
      </template>
    </popup>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { jQuery } from '~/public/theme3/js/vendor/custom';
import { produceKey } from '~/server/core/helpers';
import Popup from '~/components/common/popup/Popup.vue';

export default defineNuxtComponent({
  name: 'Theme3KnowledgeHubBox',

  mixins: [ComponentMixin],

  components: { Popup },

  data() {
    return {
      key: produceKey(),
      variants: {
        v1: 'v1',
        v2: 'v2',
        v4: 'v4',
        v1Sidebar: 'v1Sidebar',
        v2Sidebar: 'v2Sidebar',
      },
      selectedItem: null as any,
      popupConfig: { isActive: false },
    };
  },

  computed: {
    items() {
      return this.groupedVariables.items;
    },
  },

  mounted() {
    if (this.variant === this.variants.v1Sidebar || this.variant === this.variants.v2Sidebar) {
      jQuery.knowledgeHubSliderSidebar();
    } else {
      jQuery.knowledgeHubSlider();
    }
  },

  methods: {
    handleItemClick(item: any) {
      this.processItemAction(item);
    },

    processItemAction(item: any) {
      const rawForm = item.form || item.guide;
      if (rawForm) {
        const formData = this.parseFormV2(rawForm);
        if (!formData) return;
        this.selectedItem = { ...item, formData };
        this.popupConfig.isActive = true;
        return;
      }

      if (item.button_link) {
        window.location.href = item.button_link as string;
      }
    },

    closePopup() {
      this.selectedItem = null;
      this.popupConfig.isActive = false;
    },
  },
});
</script>

<style scoped>
::v-deep(.pxp-areas-carousel-right-arrow) {
  top: 40% !important;
}

::v-deep(.pxp-areas-carousel-left-arrow) {
  top: 40% !important;
}

::v-deep(.knowledge-hub-variant-2 .pxp-areas-carousel-right-arrow) {
  top: 50% !important;
}

::v-deep(.knowledge-hub-variant-2 .pxp-areas-carousel-left-arrow) {
  top: 50% !important;
}

.knowledge-hub-variant-2 .pxp-primary-cta:after {
  border-color: var(--white);
}

.knowledge-hub-variant-2 .pxp-prop-card-1-fig:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 50% black overlay */
}

.knowledge-hub-variant-2 .pxp-prop-card-1:hover .pxp-prop-card-1-fig:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(50, 205, 212, 0.3);
}
</style>
